__turbopack_context__.v({
  "amountLabel": "nWC5RG_amountLabel",
  "labelSkeleton": "nWC5RG_labelSkeleton",
  "labelWrapper": "nWC5RG_labelWrapper",
  "labelWrapperSkeleton": "nWC5RG_labelWrapperSkeleton",
  "ratingLabel": "nWC5RG_ratingLabel",
  "ratingScoreSkeleton": "nWC5RG_ratingScoreSkeleton",
  "ratingWrapper": "nWC5RG_ratingWrapper",
  "wrapper": "nWC5RG_wrapper",
});
